import { render } from "./RandevuMain.vue?vue&type=template&id=cff57b4e&scoped=true"
import script from "./RandevuMain.vue?vue&type=script&lang=js"
export * from "./RandevuMain.vue?vue&type=script&lang=js"

import "./RandevuMain.vue?vue&type=style&index=0&id=cff57b4e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cff57b4e"]])

export default __exports__